import { Col, Container } from "react-bootstrap";
import { BoxSeam, CupHot, Fire } from "react-bootstrap-icons";
import SectionHeading from "../ui/SectionHeading";
import { RevealGroup, RevealItem } from "../ui/Reveal";
import "../style/HowToCook.css";

const STEPS = [
  {
    icon: BoxSeam,
    step: "01",
    title: "Open the pack",
    text: "Straight from the fridge — no soaking, no grinding, no overnight wait.",
  },
  {
    icon: CupHot,
    step: "02",
    title: "Scoop and pour",
    text: "Pour and spread the batter on a hot tawa for dosa, or into idli plates for idlis.",
  },
  {
    icon: Fire,
    step: "03",
    title: "Cook and serve",
    text: "2–3 minutes on the flame and breakfast is on the table, hot.",
  },
];

const HowToCook = () => {
  return (
    <section className="section-pad how-to-cook">
      <Container className="container-narrow">
        <SectionHeading
          eyebrow="How to Cook"
          title="From Pack to Plate in Minutes"
        />
        <RevealGroup className="row g-4 how-to-cook__row">
          {STEPS.map(({ icon: Icon, step, title, text }, i) => (
            <Col sm={4} key={step}>
              <RevealItem delay={i * 100} className="how-to-cook__step">
                <span className="how-to-cook__number">{step}</span>
                <Icon size={28} className="how-to-cook__icon" />
                <h3>{title}</h3>
                <p>{text}</p>
              </RevealItem>
            </Col>
          ))}
        </RevealGroup>
      </Container>
    </section>
  );
};

export default HowToCook;
